// extracted by mini-css-extract-plugin
module.exports = {"child":"ChildAlert-module_child_1tooW","close":"ChildAlert-module_close_OqYkI"};